import React from "react"
import { Helmet } from "react-helmet"
import { navigate } from "gatsby"

import SignUp from "../components/signup"

import useUser from "../hooks/useUser"

import styles from "../styles/logpage.module.css"


export default () => {
    const user = useUser()
    if(user){navigate("/")}
  return(
    <div className = {styles.body}>
    <div className = {styles.authForm}>
      <Helmet>
        <title>Char.ly</title>
        <link rel="icon" href="/static/icon.png" />
      </Helmet>
      <div className = {styles.title}>
        <p className= {styles.char}>Char<p className = {styles.dot}>.</p>ly</p>
      </div>
      <div className = {styles.tagline}><p>journal your feelings away</p></div>
      <SignUp/>
      <div className = {styles.link}>
      <a className = {styles.a} href = "/signin">Already have an account? Sign in here</a>
      </div>
      </div>
      </div>
  )
}